export const reportDownload = {
  fileNotExist: "There are no downloadable files.",
  fileNotReady: "File is not ready yet, please try later.",
  files: "{0} files",
  dataType: "Data Type",
  month: "Month",
  download: "Batch Download",
  search: "Search",
  documentation: "Documentation",
  dataTypeName: {
    alert: "Alert",
    alertNoPic: "Alert(No Images)",
    driver: "Driver",
    fleet: "Fleet",
    vehicle: "Vehicle",
    maintenance: "Maintenance",
    repair: "Repair",
    trip: "Trip",
  },
};
